import { Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Listing } from "components";
import PropTypes from "prop-types";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Currency from "utils/currency";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 700
  },
  nameCell: {
    display: "flex",
    alignItems: "center"
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: "flex-end"
  },
  mono: {
    fontFamily: "Roboto Mono"
  }
}));

const Results = props => {
  const { className, models, filter, loading, onPageChange, title, ...rest } = props;

  const classes = useStyles();

  return (
    <Listing
      title={title}
      onPageChange={onPageChange}
      loading={loading}
      filter={filter}
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Currency</TableCell>
            <TableCell>Balance</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {models.map((wallet, index) => (
            <TableRow key={index}>
              <TableCell className={classes.header}>
                {wallet.currency}
                <div><Typography variant="caption">{wallet.reference}</Typography></div>
              </TableCell>
              <TableCell>
                {Currency.compress(wallet.balance)}
                <div><Typography variant="caption">Balance</Typography></div>
              </TableCell>
              <TableCell align="right">
                <Button color="primary" component={RouterLink} size="small" to={`/wallets/${wallet.id}/summary`} variant="outlined">
                  View
                  </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Listing>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  onPageChange: PropTypes.func.isRequired,
  filter: PropTypes.object.isRequired,
  models: PropTypes.array.isRequired
};

Results.defaultProps = {
  loading: false,
  onPageChange: () => { },
  models: [],
  filter: {}
};

export default Results;